import $ from 'jquery';
import { Component } from '@mycolorway/tao';
import Dialog from 'next/javascripts/components/dialog';
import eventListenerMixin from 'next/javascripts/mixins/event-listener-mixin';

Component('tr-import-dialog', {
  mixins: [eventListenerMixin],
  extends: [Dialog],

  properties: {
    uploadUrl: {
      type: String,
    },

    redirectUrl: {
      type: String,
    },

    importParams: {
      type: Object,
      default: {},
    },

    uploading: {
      type: Boolean,
      default: false,
      observer() {
        if (this.uploading) {
          window.simple.loading({
            type: 'tiny',
            msg: '正在上传中...'
          });
        } else {
          window.simple.loading.destroy();
        }
      },
    },
  },

  ready() {
    this.uploadButton = this.querySelector('.upload-button');

    this.uploader = window.simple.uploader({
      url: this.uploadUrl,
      customXhr: false,
      params: {
        conn_guid: $('#conn-guid').val(),
        authenticity_token: $('meta[name=csrf-token]').attr('content'),
        ...this.importParams,
      },
    });

    this.uploader.on('beforeupload', (e) => {
      this.uploading = true;
    });

    this.uploader.on('uploadsuccess', (e, file, result) => {
      this.uploading = false;
      window.location.href = result.redirect_url;
    });

    this.uploader.on('uploaderror', (e, xhr, status) => {
      this.uploading = false;
      if (status.status === 422) {
        window.simple.dialog.message({
          content: status.responseJSON.message
        });
      }
    });

    window.tower.connectUploader(this.uploadButton, this.uploader, {
      title: '上传文件',
      multiple: true,
    });

    this.filedrop = window.simple.filedrop({
      el: $(this).find('.uplaod-area'),
      hints: '拖曳到这里上传',
      types: ['application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
              'application/vnd.ms-excel',
              'text/csv'],
    });

    this.filedrop.on('drop', (e, files) => {
      if (files && files.length) {
        this.uploader.upload(files, {
          attachments: true,
        });
      }
    });

    this.filedrop.on('dropfail', (e, files) => {
      window.simple.dialog.message({
        content: '请上传 csv 或 xlxs 格式的文件',
      });
    });
  },

  disconnected() {
    this.filedrop.destroy()
    this.stopListening();
  },
});
